import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../../service/app.service';
import { Attori } from '../enum/attori.enum';

@Injectable({
  providedIn: 'root',
})
export class ControllerCentraleGuard {
  constructor(
    private router: Router,
    private appService: AppService
  ) {}

  canActivate(): boolean {
    if (this.appService.attore === Attori.ControllerCentrale) {
      return true;
    }
    this.router.navigate(['homepage']);
    return false;
  }
}
